import { BriefcaseIcon, UsersIcon, AcademicCapIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import './About.css';


const features = [
  {
    name: 'Job Listings',
    description:
      'Explore a wide variety of job listings from top companies in various industries. Find the best match for your skills and interests.',
    icon: BriefcaseIcon,
  },
  {
    name: 'Resume Building',
    description:
      'Create a professional resume with our easy-to-use templates and tools to showcase your experience and skills to potential employers.',
    icon: AcademicCapIcon,
  },
  {
    name: 'Networking Opportunities',
    description:
      'Connect with professionals, recruiters, and peers in your industry to expand your network and open up new career opportunities.',
    icon: UsersIcon,
  },
  {
    name: 'Job Alerts',
    description:
      'Get notified about new job postings based on your preferences so you never miss an opportunity that matches your career goals.',
    icon: CheckCircleIcon,
  },
];

export default function JobMarket() {
  return (
    
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <br></br>
        <h2 className="text-3xl sm:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-600">
  Find Your Dream Job
</h2>
<br></br>
<p className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-600 leading-tight tracking-tight transform transition-all duration-500 hover:scale-105 hover:underline">
  Connecting Talent with Opportunity
</p>
<br></br>
          <p className="mt-6 text-lg/8 text-gray-600">
            We help job seekers connect with top employers, build resumes, and stay updated with the latest job opportunities.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-16">
                <dt className="text-base/7 font-semibold text-gray-900">
                  <div className="absolute left-0 top-0 flex size-10 items-center justify-center rounded-lg bg-blue-900">
                    <feature.icon aria-hidden="true" className="size-6 text-white" />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-2 text-base/7 text-gray-600">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
        <br></br>
      </div>
      
      <section id="about" className="about">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>About</h2>
        <p>Connecting talent with opportunity in a rapidly evolving job market</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6 content" data-aos="fade-up" data-aos-delay="100">
            <p>
              In today's fast-paced world, the job market is constantly evolving. We aim to bridge the gap between talented professionals and the right job opportunities by providing a platform that helps both job seekers and employers find their perfect match.
            </p>
            <br></br>
            <ul>
              <li><CheckCircleIcon className="inline-block h-6 w-6" /> <span>Access to thousands of job listings across industries.</span></li>
              <li><CheckCircleIcon className="inline-block h-6 w-6" /> <span>Tools for career growth, skill development, and networking.</span></li>
              <li><CheckCircleIcon className="inline-block h-6 w-6" /> <span>Advanced job matching technology for better job recommendations.</span></li>
            </ul>
          </div>

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <p>
              The job market is more competitive than ever, but with the right resources, you can stand out. We provide insights into market trends, salary benchmarks, and industry forecasts to ensure you're making informed career decisions. Whether you're looking for your first job or your next big opportunity, we are here to help you succeed.
            </p>
            <br></br>
            <a href="#" className="read-more">
              <button>Learn More </button>
              <i className="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}
